import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { forgotPassword } from '../actions/auth';
import Validator from './common/forms/Validator';
import ErrorMessage from './common/forms/ErrorMessage';
import BackArrow from './common/ui/BackArrow';
import ContentWrapper from './common/ContentWrapper';

class ResetPassword extends Validator {
  static propTypes = {
    forgotPassword: PropTypes.func.isRequired
  };

  validationRules = { email: { email: true } };

  state = {
    email: '',
    passwordWasSent: false
  };

  handleChangeEmail = event => {
    this.setState({
      email: event.target.value
    });
  };

  submitResetPassword = event => {
    event.preventDefault();

    if (this.validate(this.validationRules)) {
      const email = this.state.email.toLowerCase();
      const { forgotPassword } = this.props;
      const formData = {
        email,
        type: 'email'
      };
      forgotPassword(formData);
      this.setState({
        passwordWasSent: true
      });
    }
  };

  render () {
    const { email, passwordWasSent } = this.state;
    return (
      <ContentWrapper full>
        <div className='auth-form-wrapper'>
          <div className='d-flex align-center mb-3'>
            <BackArrow
              history={this.props.history}
              location={this.props.location}
            />
            <h1 className='w-100'>Password Recovery</h1>
          </div>
          <form className='form-group' onSubmit={this.submitResetPassword}>
            <div className='form-group'>
              <label htmlFor='email'>Email</label>
              <input
                className='input'
                value={email}
                onChange={this.handleChangeEmail} type='email' id='email' />
              <ErrorMessage errorText={this.validationErrors.email} />
            </div>
            <div className='mb-3'>
              { passwordWasSent ? (
                'Temporary password was sent to your email.'
              ) : (
                'Enter your email and we\'ll send you a temporary password.'
              )}
            </div>
            <button type='submit' className='button button-primary w-100'>Send password</button>
          </form>
        </div>
      </ContentWrapper>
    );
  }
}

export default connect(null, { forgotPassword })(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/ResetPassword.js